import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { InvoiceDemoData } from '../../../../../data/InvoiceDemoData';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { handleLoadInvoiceInfo } from '../InvoiceOperation';

const InvoiceInfoContext = createContext();
export const useInvoiceInfo = () => useContext(InvoiceInfoContext);

function InvoiceInfoProvider({ children, id }) {
    const [reloadKey, setReloadKey] = useState(0);
    const [invoiceInfo, setInvoiceInfo] = useState(InvoiceDemoData);
    // --Modal open handler
    const [showModal, setShowModal] = useState({
        type: '',
        data: null
    });

    const { setMessage } = useTemplate();

    // -- Load invoice info by invoiceId
    useEffect(() => {
        handleLoadInvoiceInfo(id)
            .then(({ data }) => {
                setInvoiceInfo(data);
                // setMessage({ type: 'success', text: title });
            })
            .catch((err) => {
                setInvoiceInfo({});
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [setMessage, id, reloadKey]);

    const value = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
            setInvoiceInfo(InvoiceDemoData);
        };

        // --Handler to open modal
        const openModal = (type, data) => {
            setShowModal({
                type,
                data
            });
        };
        // --Handler to close modal
        const closeModal = () => {
            setShowModal({
                type: '',
                data: null
            });
        };

        return {
            openModal,
            closeModal,
            modalType: showModal?.type,
            modalData: showModal?.data,
            // Reload Key
            reloadKey,
            setReloadKey,
            // -- invoice info
            invoiceInfo,
            setInvoiceInfo,

            // All Handler
            handleReload
        };
    }, [invoiceInfo, reloadKey, showModal.data, showModal.type]);

    return <InvoiceInfoContext.Provider value={value}>{children}</InvoiceInfoContext.Provider>;
}

export default InvoiceInfoProvider;
